var _style, _path, _path2, _path3, _rect, _path4, _path5, _path6, _circle, _circle2, _path7, _rect2, _path8, _circle3, _circle4, _path9, _path10, _path11, _path12, _path13, _path14, _rect3, _g, _g2, _path15, _rect4, _path16, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E24B4B;}\n\t.st1{fill:#E6E6E6;}\n\t.st2{fill:#C13A3A;}\n\t.st3{fill:#333333;}\n\t.st4{fill:#4D4D4D;}\n\t.st5{fill:#808080;}\n\t.st6{fill:#666666;}\n\t.st7{fill:#EA7168;}\n\t.st8{fill:#E2E4E8;}\n\t.st9{fill:#8E4D4D;}\n\t.st10{fill:#FFFFFF;}\n\t.st11{clip-path:url(#SVGID_2_);fill:none;stroke:#4D4D4D;stroke-width:18;stroke-miterlimit:10;}\n\t.st12{fill:#F69B76;}\n\t.st13{fill:#F8C09D;}\n\t.st14{fill:#EF937E;}\n\t.st15{fill:#F6AE8D;}\n\t.st16{fill:#E26C60;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M602,398.2c0,0-41,46.9-86.2,174.4c-49.4,139.3-49.4,217.9-49.4,217.9h67.8L602,398.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1464.1,823.7H447.5l105-288.5h768c79.3,0,143.5,68,143.5,151.9V823.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M579.8,824.5H445.6c-11.7,0-21.2-9.5-21.2-21.2v-14.5c0-11.7,9.5-21.2,21.2-21.2h134.2V824.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 752.6,
    y: 784.8,
    className: "st2",
    width: 396.8,
    height: 38.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1307.6,824.5h168c11.7,0,21.2-9.5,21.2-21.2v-14.5c0-11.7-9.5-21.2-21.2-21.2h-168V824.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M666.2,717.8c-58.4,0-105.7,47.3-105.7,105.7h211.4C771.9,765.1,724.6,717.8,666.2,717.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1446.8,840.8H471.7c-9.6,0-17.3-7.7-17.3-17.3v0h1009.7v0C1464.1,833,1456.3,840.8,1446.8,840.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 666.2,
    cy: 823.5,
    r: 86.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 666.2,
    cy: 823.5,
    r: 47.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M629,833.5c0-26.1,21.1-47.2,47.2-47.2c10.5,0,20.2,3.4,28,9.2c-8.6-11.7-22.4-19.2-38-19.2 c-26.1,0-47.2,21.1-47.2,47.2c0,15.6,7.6,29.4,19.2,38C632.4,853.7,629,844,629,833.5z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1221.8,
    y: 584.4,
    className: "st2",
    width: 18.7,
    height: 206.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1235.8,717.8c-58.4,0-105.7,47.3-105.7,105.7h211.4C1341.5,765.1,1294.1,717.8,1235.8,717.8z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1235.8,
    cy: 823.5,
    r: 86.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 1235.8,
    cy: 823.5,
    r: 47.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1198.5,833.5c0-26.1,21.1-47.2,47.2-47.2c10.5,0,20.2,3.4,28,9.2c-8.6-11.7-22.4-19.2-38-19.2 c-26.1,0-47.2,21.1-47.2,47.2c0,15.6,7.6,29.4,19.2,38C1202,853.7,1198.5,844,1198.5,833.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1396.2,584.4H546.4l14.1-35.2H1311C1343,549.2,1377.4,562.4,1396.2,584.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1273.8,548.9H552.5v0c0-143.9,116.6-260.5,260.5-260.5h302.8c13.9,0,26.7,7.8,33.1,20.1L1273.8,548.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M597.5,515c-7.4,0-12.2-7-9-13c13-24.6,23.7-55.8,84.6-117.6c44.7-45.4,91.4-56.8,116.4-64.4 c6.5-1.9,13.2,2.5,13.2,8.7v177.2c0,5-4.5,9.1-10,9.1H597.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M930.2,640.5h-50c-5.4,0-9.8-4.4-9.8-9.8l0,0c0-5.4,4.4-9.8,9.8-9.8h50c5.4,0,9.8,4.4,9.8,9.8l0,0 C940,636.2,935.6,640.5,930.2,640.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1190.8,515H858.2c-8,0-14.5-6.5-14.5-14.5V334c0-8,6.5-14.5,14.5-14.5h247.2c5.4,0,10.4,3,12.9,7.9l85.4,166.5 C1208.6,503.5,1201.6,515,1190.8,515z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 825,
    y: 584.4,
    className: "st2",
    width: 18.7,
    height: 206.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M803,388v-59.4c0-1.1-0.4-2.1-0.8-3.1L591.1,497.1c-0.8,1.6-1.7,3.3-2.5,4.8c-3.2,6,1.6,13.1,9,13.1h49 L803,388z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "803,423.6 803,405.8 668.4,515 690.3,515  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M803,388v-59.4c0-1.1-0.4-2.1-0.8-3.1L591.1,497.1c-0.8,1.6-1.7,3.3-2.5,4.8c-3.2,6,1.6,13.1,9,13.1h49 L803,388z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1137,363.6 1115,323 900,515 957.3,515  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1167,423.6 1158.400,405 1035,515 1057.3,515  "
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1392.8,608.6c-2.9,0-5.7,0.6-8.3,1.7v68.1c2.6,1.1,5.4,1.7,8.3,1.7c15,0,27.2-16,27.2-35.7 C1420,624.6,1407.8,608.6,1392.8,608.6z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1360.8,
    y: 601.6,
    className: "st2",
    width: 19.9,
    height: 85.4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1384.2,687.1h-3.6v-85.4h3.6c5.4,0,9.7,4.3,9.7,9.7v66C1393.9,682.7,1389.6,687.1,1384.2,687.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1412.3,733.2h-43.8c-4.3,0-7.7-3.5-7.7-7.7l0,0c0-4.3,3.5-7.7,7.7-7.7h43.8c4.3,0,7.7,3.5,7.7,7.7l0,0 C1420,729.8,1416.5,733.2,1412.3,733.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "1155.9,402.9 1217,515 1098.3,515 1085.9,435.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCar);
export default __webpack_public_path__ + "static/media/redCar.e0c55d3d1f6ef4bc30d6b20c0720c850.svg";
export { ForwardRef as ReactComponent };